import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@babel/polyfill'
import './plugins/element.js'
import './plugins/vant.js'
import './plugins/have'
import './assets/css/base.css'
import mixin from './mixin/index'
import './api/createApi'
import Vconsole from 'vconsole'

Vue.config.productionTip = false
Vue.mixin(mixin)
const { VUE_APP_AMBIENT } = process.env
// && VUE_APP_AMBIENT !== 'development'
if(VUE_APP_AMBIENT !== 'prod' ) {
  const vConsole = new Vconsole()
  Vue.use(vConsole)
}

router.beforeEach((to, from, next) => {
    const { title = null } = to.meta
    if (title) {
        document.title = title
    }
    next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
